var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "マスタ > その他",
            size: "lg",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "b-form-select",
            {
              staticStyle: { width: "200px" },
              on: { change: _vm.selSubmit },
              model: {
                value: _vm.on_submit,
                callback: function ($$v) {
                  _vm.on_submit = $$v
                },
                expression: "on_submit",
              },
            },
            [
              _c("option", { attrs: { disabled: "", value: "-1" } }, [
                _vm._v("マスタを選択"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.sel_on_submit, function (option) {
                return _c(
                  "option",
                  { key: option.id, domProps: { value: option.value } },
                  [_vm._v("\n        " + _vm._s(option.text) + "\n      ")]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-top": "10px" } }, [
            _vm.on_submit == 0
              ? _c(
                  "div",
                  [_c("MasterItemType", { ref: "child_master_item_type" })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.on_submit == 1
              ? _c(
                  "div",
                  [_c("MasterItemTax", { ref: "child_master_item_tax" })],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }